import React from 'react';
import styles from './OnboardingStepper.module.css';

export default function OnboardingStepper({ steps, activeIndex }) {
  return (
    <div className={styles.steps}>
      {steps.map((step, i) => {
        const state = i < activeIndex ? 'done' : i === activeIndex ? 'active' : '';
        return (
          <div key={step.key} className={`${styles.step} ${state ? styles[state] : ''}`}>
            {i > 0 && <span className={styles.line} />}
            <div className={styles.node}>{i < activeIndex ? '✓' : i + 1}</div>
            <div className={styles.title}>{step.title}</div>
            {step.description && <div className={styles.desc}>{step.description}</div>}
          </div>
        );
      })}
    </div>
  );
}
